<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="your-name-is-written"><br/><br/><br/>
<p style="text-indent:0em"><strong>Like rain you can hear all around you</strong></p>
<p style="text-indent:0em"><strong>That doesn’t reach the ground</strong></p><br/>
<p style="text-indent:0em">The voices that said come here</p>
<p style="text-indent:0em">Were over there or overhead</p>
<p style="text-indent:0em">Always moving and not taking me kindly</p>
<p style="text-indent:0em">Now I wake up one morning on a rock</p>
<p style="text-indent:0em">Unable to shape it to comfortable</p>
<p style="text-indent:0em">Reaching a no place like this</p>
<p style="text-indent:0em">By what compass do I judge</p>
<p style="text-indent:0em">To take now my bearing?</p><br/>
<p style="text-indent:0em">Is it follow our nose now</p>
<p style="text-indent:0em">Though we would say our hearts?</p>
<p style="text-indent:0em">There is no handholding</p>
<p style="text-indent:0em">Or perhaps we don’t feel it</p>
<p style="text-indent:0em">The human factor makes the world</p>
<p style="text-indent:0em">In its parch mouth image</p><br/>
<p style="text-indent:0em">Those who start out with water in the bottle</p>
<p style="text-indent:0em">End up in the bottle themselves and being hurled</p>
<p style="text-indent:0em">Being high up all streams</p>
<p style="text-indent:0em">Tend down and down and become</p>
<p style="text-indent:0em">Strong sources of life to the plains</p>
<p style="text-indent:0em">Waking up green again</p>
<p style="text-indent:0em">Springs become spring</p>
<p style="text-indent:0em">That is me too</p>
<p style="text-indent:0em">Waking up and green</p>
<p style="text-indent:0em">But naming that from here</p>
<p style="text-indent:0em">Is possibly a whisper of the grave</p><br/>
<p style="text-indent:0em">Creating urgency</p>
<p style="text-indent:0em">Creating nothing</p>
<p style="text-indent:0em">Standing still too long is wrong too</p>
<p style="text-indent:0em">Though there is nowhere more alone</p>
<p style="text-indent:0em">Let us take counsel of those who love us</p>
<p style="text-indent:0em">And go now</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?51956bc6